export class CryptoSymbol {
    static IsCryptoSymbol = (src: string) => /^X:/.test(src);
}
